import { CategoryStructure, useCategories } from "./useCategories";

export function useCategoriesTree() {
    return useCategories({ structure: CategoryStructure.TREE });
}
